import './App.css';
import Clock from './Componets/Clock/Clock';
import TodoWrapper from './Componets/TodoWrapper/TodoWrapper';

function App() {
  return (
    <div className="App">
      <TodoWrapper/>
      <Clock/>
    </div>
  );
}

export default App;
